import { useState, useEffect, StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Outlet, RouterProvider, createBrowserRouter } from 'react-router';
import { FlagProvider } from '@unleash/proxy-client-react';

import App from './app';
import { routesSection } from './routes/sections';
import { CONFIG } from './global-config';
import axios from 'axios';

const RootWrapper = () => {
  const [configState, setConfigState] = useState<boolean | null>(null);

  useEffect(() => {
    try {
      (async () => {
        const config = await axios.get<(typeof window)['RUNTIME_CONFIG']>(`/config/config.json`);

        window.RUNTIME_CONFIG = config.data;
        setConfigState(true);
      })();
    } catch {
      setConfigState(false);
    }
  }, []);

  if (configState) {
    return (
      <FlagProvider
        config={{
          url: window.RUNTIME_CONFIG.UNLEASH_URL,
          clientKey: window.RUNTIME_CONFIG.UNLEASH_CLIENT_KEY,
          appName: window.RUNTIME_CONFIG.UNLEASH_APP_NAME,
          environment: window.RUNTIME_CONFIG.UNLEASH_ENVIRONMENT || 'development',
        }}
      >
        <RouterProvider router={router} />
      </FlagProvider>
    );
  }

  if (configState === false) return <div>Error Fetching Configuration File</div>;

  return null;
};

const router = createBrowserRouter([
  {
    Component: () => (
      <App>
        <Outlet />
      </App>
    ),
    children: routesSection,
  },
]);

declare global {
  interface Window {
    RUNTIME_CONFIG: {
      UNLEASH_URL: string;
      UNLEASH_CLIENT_KEY: string;
      UNLEASH_APP_NAME: string;
      UNLEASH_ENVIRONMENT: string;
      KEYCLOAK_AUTHORITY: string;
      KEYCLOAK_REALM: string;
      KEYCLOAK_CLIENT: string;
      KEYCLOAK_REDIRECT_URI: string;
      FILE_SERVICE: string;
      PRESENTATION_SERVICE: string;
      CLIENTS_SERVICE: string;
      PAYMENT_VALIDATION_TOLERANCE_DEFAULT: number;
      MAX_LOGO_SIZE_KB: number;
      MAX_BANNER_SIZE_KB: number;
      QS_DASHBOARD_REFRESH_SKEW_MS?: number;
      QS_DASHBOARD_FALLBACK_LIFETIME?: number;
    };
    OIDC_CONFIG: {
      authority: string;
      client_id: string;
      redirect_uri: string;
      response_type: string;
      scope: string;
      automaticSilentRenew: boolean;
    };
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RootWrapper />
  </StrictMode>
);
